<section class="content tab-section d-flex flex-column" *ngIf="!isAdmin">
  <div class="content-block flex-grow-1 d-flex flex-column">
    <div [ngTemplateOutlet]="viewContent"></div>
  </div>
</section>
<div *ngIf="isAdmin">
  <div [ngTemplateOutlet]="viewContent"></div>
</div>
<ng-template #viewContent>
  <div class="tab-content flex-grow-1 d-flex flex-column">

    <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap mb-24">
      <div class="d-flex align-items-center">
        <div class="me-2 cursor-pointer" (click)="onBack()"><img src="assets/images/icons/back_icon.svg" alt=""></div>
        <h5 class="text-black m-0">{{courseName}} </h5>
      </div>
      <div class="d-flex">
        <div class=" " *ngIf="!isAdminCourse">
          <button type="button" class="btn btn-icon btn-outline-primary d-flex me-3 align-items-center"
            (click)="onEditCourse()">
            <img src="assets/images/icons/edit_without_bg.png" class="img-fluid me-1" alt=""> {{"Edit"
            |translate}}</button>
        </div>
        <div class="">
          <button mat-raised-button type="button" class="btn btn-icon btn-primary  d-flex align-items-center no-sh-btn"
            (click)="onAssignCourse()">
            <img src="assets/images/icons/asign-cource-white.svg" class="img-fluid me-1" alt=""> {{"Assign"
            |translate}}</button>
        </div>
      </div>
    </div>

    <div class="box-container justify-content-center mt-1 mt-sm-0 gap-3">
      <div class="box d-flex flex-column justify-content-between cursor-pointer" *ngFor="let item of boxArr"
        [ngClass]="{'sel-box':item.selected==true}" (click)="onBoxSelected(item)">
        <div class="box-content d-flex flex-wrap flex-md-nowrap">
          <div class="box-img">
            <img [src]="item.cont_img" class="img-fluid">
          </div>
          <div class="box-text ms-md-2">
            <div class="normal-mark">
              <span class="big-txt " [ngClass]="{
                          'success-color': item.content_type === 'completed',
                          'pending-color': item.content_type === 'pending',
                          'not-attended-color': item.content_type === 'not started',
                          'exam-attended-color': item.content_type === 'exam attended',
                          'deadline-color': item.content_type === 'missed deadline' }">
                <span *ngIf="item.content_type === 'completed'">{{courseStatistics.total_completed}}</span>
                <span *ngIf="item.content_type === 'pending'">{{courseStatistics.total_progress}}</span>
                <span *ngIf="item.content_type === 'not started'">{{courseStatistics.total_not_started_course }}</span>
                <span *ngIf="item.content_type === 'exam attended'">{{courseStatistics.total_attend_exam }}</span>
                <span *ngIf="item.content_type === 'missed deadline'">{{courseStatistics.total_missed}}</span>
              </span> / {{courseStatistics.total_assign_course }} <span class="em text-semibold">(Employees)</span>
            </div>
            <div class="completed-txt">{{item.text | translate}}</div>
          </div>
        </div>
        <div class="box-progress mt-2 mt-md-3 mt-lg-4 d-flex align-items-center  ">
          <mat-progress-bar mode="determinate" class="progress-m progress-round  progress-shadow"
            [ngClass]="item.progress_bar_color" [value]="item.percentage"></mat-progress-bar>
          <span class="ms-2 text-semibold steel-blue">{{item.percentage}}%</span>
        </div>
      </div>
    </div>
    <div class="search-cont mt-4">
      <div class="s-in form-input" style="position:relative">
        <mat-icon class="input-icon">search</mat-icon>
        <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
          (input)="onSearch($event)" (keyup.enter)="onGo()" />
      </div>
      <div class="go-b" (click)="onGo()">Go</div>
      <div class="s-item d-box " (click)="onFilterView()">
        <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
      </div>
    </div>

    <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
    <div class="d-flex flex-column data-tab p-24 flex-grow-1 mt-4">

      <div class="flex-grow-1" style="overflow-x:auto" #targetElement>
        <table class="mt-3" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
          class="mat-elevation-z8" *ngIf="dataSource.data.length!=0">

          <ng-container matColumnDef="user_info">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex">
                <div class="profile-img me-2 " style="flex-shrink:0">
                  <img *ngIf="!element.employee_image" src="assets/images/icons/employee.png" class="img-fluid" alt="">
                  <img *ngIf="element.employee_image" [src]="imageURL+element.employee_image" class="img-fluid"
                    onerror="this.src='assets/images/icons/employee.png';" alt="">
                </div>
                <div class="">
                  <div>{{element.employee_first_name }} {{element.employee_last_name}}</div>
                  <div class="steel-blue">{{element.employee_email }}</div>
                </div>
              </div>
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="completed_practical">
            <th mat-header-cell *matHeaderCellDef class="text-center min-t-width"> Completed Practical ?
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <mat-checkbox (change)="changeCoursePractical($event, element)" [checked]="element.is_pr==1"
                [color]="'primary'">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="certificate_access">
            <th mat-header-cell *matHeaderCellDef class="text-center min-t-width"> Give Certificate Access to user </th>
            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
              <mat-checkbox [checked]="element.m_c_g==1" [color]="'primary'"
                [ngClass]="{'disabled-btn': !element.m_c_g}" (change)="changeCertifcateAccess($event, element)">
              </mat-checkbox>
            </td>
          </ng-container> -->
          <ng-container matColumnDef="completed_practical">
            <th mat-header-cell *matHeaderCellDef class="text-center min-t-width"> Completed Practical ?
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <mat-checkbox (change)="changeCoursePractical($event, element)" [disabled]="element.m_c_g1 == 0"
                [ngClass]="{'disabled-btn': element.m_c_g1 == 0}" [checked]="element.is_pr==1 && element.m_c_g1 != 0"
                [color]="'primary'">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="certificate_access">
            <th mat-header-cell *matHeaderCellDef class="text-center min-w-145"> Give Certificate Access to user
            </th>
            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
              <mat-checkbox [checked]="element.m_c_g==1 && element.m_c_g1 != 0 && element.is_pr!=0"
                [disabled]="element.m_c_g1 == 0 || element.is_pr==0" [color]="'primary'"
                [ngClass]="{'disabled-btn': element.m_c_g1 == 0 && element.is_pr==0}"
                (change)="changeCertifcateAccess($event, element)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="manager">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Manager</th>
            <td mat-cell *matCellDef="let element"> {{element.manager_first_name}} {{element.manager_last_name}}</td>
          </ng-container>
          <ng-container matColumnDef="training_date">
            <th mat-header-cell *matHeaderCellDef> Training Date</th>
            <td mat-cell *matCellDef="let element"> {{element.tr_dt | dates : 'date_time'}} </td>
          </ng-container>
          <ng-container matColumnDef="deadline_date">
            <th mat-header-cell *matHeaderCellDef> Deadline Date</th>
            <td mat-cell *matCellDef="let element"> {{element.de_dt | dates : 'date_time'}} </td>
          </ng-container>
          <ng-container matColumnDef="department">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Department</th>
            <td mat-cell *matCellDef="let element"> {{element.dep}} </td>
          </ng-container>
          <ng-container matColumnDef="course_progres">
            <th mat-header-cell *matHeaderCellDef>Course Progress</th>
            <td mat-cell *matCellDef="let element">
              <mat-progress-bar mode="determinate" class="progress-m progress-round green-progress progress-shadow"
                [value]="element.per"></mat-progress-bar>
              <div class="text-center per-b">{{element.per}}% </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex  ">

                <div class="d-flex" *ngIf=" element.m_c_g1 == 0 || (element.m_c_g1 == 1 && element.is_pr == 1)">
                  <div class="action-icon  me-2 " (click)="onViewExamSheet(element)" *ngIf="element.is_att"
                    matTooltip="View Exam Sheet">
                    <img src="assets/images/icons/view_icon.png" class="img-fluid" alt="">
                  </div>
                  <!-- add is_p here is certificate exist -->
                  <div class="action-icon  me-2 " *ngIf="(element.c_img && (element.is_p==1)) "
                    matTooltip="Certificate Download" (click)="onCertificateDownload(element)">
                    <img src="assets/images/icons/certificate_ic.svg" class="img-fluid">
                  </div>
                  <div class="action-icon   me-2" (click)="onMoreInfo(element)" matTooltip="More Course Info"
                    *ngIf="element.is_att">
                    <img src="assets/images/icons/more_info.svg" class="img-fluid">
                  </div>
                </div>
                <!-- <div class="action-icon  me-2 " (click)="onViewExamSheet(element)" *ngIf="element.is_att"
                  matTooltip="View Exam Sheet">
                  <img src="assets/images/icons/view_icon.png" class="img-fluid" alt="">
                </div>
                <div class="action-icon me-2 " *ngIf="element.c_img" (click)="onCertificateDownload(element)"
                  matTooltip="Certificate Download">
                  <img src="assets/images/icons/certificate_ic.svg" class="img-fluid">
                </div>
                <div class="action-icon  me-2" (click)="onMoreInfo(element)" matTooltip="More Course Info"
                  *ngIf="element.is_att">
                  <img src="assets/images/icons/more_info.svg ">
                </div> -->

                <div class="action-icon" (click)="onDeleteItem(element)" matTooltip="Delete Course">
                  <img src="assets/images/icons/delete-icon.svg">
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="mat-table__message" *ngIf="dataSource.data.length==0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>

      </div>

      <div class="d-flex justify-content-between align-items-center flex-wrap" *ngIf="dataSource.data.length!=0">
        <div class="me-3 text-grey d-flex align-items-center mt-2 mt-sm-0">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div>
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</ng-template>